<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Consultor Cliente</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div [formGroup]="form" class="py-2">
    <div class="flex justify-between gap-4 items-center">
      <mat-form-field
        class="input-tg mt-message-input w-3/12"
        appearance="outline"
      >
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" />
      </mat-form-field>

      <mat-form-field
        class="input-tg mt-message-input w-3/12"
        appearance="outline"
      >
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" />
      </mat-form-field>

      <mat-form-field
        class="input-tg mt-message-input w-2/12"
        appearance="outline"
        [floatLabel]="
          this.form.get('phone')?.value &&
          this.form.get('phone')!.value.length > 0
            ? 'always'
            : 'auto'
        "
      >
        <mat-label>Telefone</mat-label>
        <input matInput formControlName="phone" [mask]="'(99) 99999-9999'" />
      </mat-form-field>

      <mat-form-field
        class="input-tg mt-message-input w-2/12"
        appearance="outline"
      >
        <mat-label>Data nascimento</mat-label>
        <input
          matInput
          [matDatepicker]="birth"
          (focus)="openDatepicker()"
          formControlName="birth"
          [max]="maxDate"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="birth"
        ></mat-datepicker-toggle>
        <mat-datepicker #birth></mat-datepicker>
      </mat-form-field>

      <button
        mat-flat-button
        class="btn-tg w-2/12"
        [disabled]="form.invalid || loading"
        (click)="createConsultant()"
      >
        @if (loading) {
          <mat-spinner
            diameter="22"
            class="loading-spinner"
            selected-track-color="red"
          ></mat-spinner>
        } @else {
          Adicionar
        }
      </button>
    </div>
  </div>
</mat-card>
